import ButtonToggle from '../modules/button-toggle';
import { getCookie, setCookie } from '../utils/handle-cookies';
import tabbableElements from "../utils/tabbable";

export default function CookieBanner() {
  const cookieBanner = document.getElementById("cookie-banner");

  // If the cookie banner is present init.
  if (!cookieBanner) {
    return;
  }

  // Set Cookie Banners Cookies and Toggle
  const dismissCookieTarget = document.querySelector('.btn--dismiss-cookie');
  if (!dismissCookieTarget) {
      return;
  }
    
  const dismissCookieToggle = new ButtonToggle({ resetAt: -1 });
  dismissCookieToggle.add('.btn--dismiss-cookie').run();

  // When user clicks dismiss button...
  dismissCookieTarget.addEventListener('click', () => {
    // Set an accepted cookie.
    setCookie('CookiesAcknowledged', true, '365', '/');
    // Hide focusable elements from focus.
    focusable(cookieBanner, false);
  })

  // Check cookies to see if they've been accepted.
  if (getCookie('CookiesAcknowledged') === 'true') {
    dismissCookieTarget.toggleButton(true);
    focusable(cookieBanner, false);
  } else {
    // Remove tab index "non focus" from focusable elements.
    focusable(cookieBanner, true);
  }
}

function focusable(thisElement, setFocus) {

  // Set this element to be shown/hidden from the screen reader
  if (setFocus == true) {
    thisElement.removeAttribute('inert');
    thisElement.removeAttribute('aria-hidden');
  } else {
    thisElement.setAttribute('inert', true);
    thisElement.setAttribute('aria-hidden', 'true');
  }

  // Still need a few attributes until inert is more widely compatible.
  thisElement.querySelectorAll(tabbableElements).forEach(element => {
    if (setFocus == true) {
      element.removeAttribute('tabindex');
      element.removeAttribute('aria-hidden');
      element.removeAttribute('disabled');
    } else {
      element.setAttribute('tabindex', '-1');
      element.setAttribute('aria-hidden', 'true');
    }
  })
}